// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ly-0";
export var assigneeDetails = "_ly-1";
export var assigneeInfo = "_ly-2";
export var dropdownContainer = "_ly-4";
export var dropdownImage = "_ly-5";
export var editAssigneeInfo = "_ly-3";
export var editAssigneeModalContainer = "_ly-6";
export var hidden = "_ly-8";
export var input = "_ly-7";